import { noop } from '@/utils/util';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import styles from './EditorTitle.scss';

import { setNoteData } from '../../actions/GlobalAction';
import { getState } from '../../reducers/Notes/NotesReducer';
import { getState as getGlobalState } from '../../reducers/Global/GlobalReducer';

@withRouter
@connect(
  state => ({
    global: getGlobalState(state),
    notes: getState(state),
  }),
  dispatch => ({
    setNoteData: data => dispatch(setNoteData(data)),
  }),
)
export default class EditorTitle extends Component {
  static defaultProps = {
    onTitleChanged: noop,
  };

  constructor(props) {
    super(props);
    const title = this.getTitle(this.props);
    this.title = title;
    this.state = {
      title,
    };
    const { match, onTitleChanged } = this.props;
    const { params: { noteId } } = match;
    onTitleChanged({
      title,
      noteId,
    }, true);
  }

  componentDidMount() {
    const { isInit } = this.props.global.get('noteData').toJS();
    // 新创建的文章需要focus标题
    if (isInit) {
      this.focusTheTitle();
      this.props.setNoteData({ isInit: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { match, onTitleChanged } = nextProps;
    const { params: { noteId } } = match;
    // 文章切换时
    if (noteId !== this.props.match.params.noteId) {
      const title = this.getTitle(nextProps);
      this.setState({
        title,
      });
      onTitleChanged({
        title,
        noteId,
      }, true);
    }
  }

  focusTheTitle = () => {
    setTimeout(() => {
      if (this.titleInput) {
        this.titleInput.select();
      }
    }, 0);
  };

  getTitle = (props) => {
    const { notes, match } = props;
    const { params: { noteId } } = match;
    return notes.getIn(['entities', noteId, 'title']) || '';
  };

  titleChange = (e) => {
    const { onTitleChanged, match } = this.props;
    const { params: { noteId } } = match;
    const title = (e.target.value || '');
    this.setState(prevState => ({ title }), () => {
      if (this.titleChangeTimer) {
        clearTimeout(this.titleChangeTimer);
        this.titleChangeTimer = null;
      }
      this.titleChangeTimer = setTimeout(() => {
        if (this.title !== title) {
          this.title = title;
          // 此处回传noteId的目的是保证快速切换文章时数据能准确
          onTitleChanged({
            title: title.trim(),
            noteId,
          });
        }
      }, 500);
    });
  };

  render() {
    const { isWritingMode } = this.props;
    const clazz = classNames(styles['editor-title'], {
      [styles['editor-title-writing-mode']]: isWritingMode,
    });
    return (
      <input
        type="text"
        className={clazz}
        value={this.state.title}
        onChange={this.titleChange}
        ref={(v) => {
          this.titleInput = v;
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/EditorTitle.js